export default "__VITE_ASSET__Iwu3Irdc__"